import request from './request';

export function getIntegral() {
    return request
        .post('/api/guest/member/getIntegralTips')
        .then(({ data = {} }) => {
            return data.data;
        });
}
